import { render, staticRenderFns } from "./MerchantSettings.vue?vue&type=template&id=7a507fc2&scoped=true"
import script from "./MerchantSettings.vue?vue&type=script&lang=js"
export * from "./MerchantSettings.vue?vue&type=script&lang=js"
import style0 from "./MerchantSettings.vue?vue&type=style&index=0&id=7a507fc2&prod&lang=scss&scoped=true"
import style1 from "./MerchantSettings.vue?vue&type=style&index=1&id=7a507fc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a507fc2",
  null
  
)

export default component.exports